module.exports = __webpack_public_path__ + "img/goods1_3.acad0d8c.jpg";